export default __webpack_public_path__ + "static/sprite-bg-6995d58243165af4af9a82e621500a43.png";